<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 


<div class="columns is-centered mt-6">

<div class="column is-6 box has-background-light">
<div class="columns is-gapless is-multiline">
<div class="column is-12 underIT">EMAIL !! !!</div>

<div class="column is-5 mt-4 is-size-7">HOST</div>
<div class="column is-2 mt-4 is-size-7">PORT</div>
<div class="column is-5 mt-4 is-size-7">FROM EMAIL</div>


<div class="column is-5"><input v-model="email_server" placeholder="...." class="input is-fullwidth"></div>
<div class="column is-2"><input v-model="email_server" placeholder="...." class="input is-fullwidth"></div>
<div class="column is-5"><input v-model="email_server" placeholder="...." class="input is-fullwidth"></div>


<div class="column is-6 mt-4 is-size-7">USERNAME</div>
<div class="column is-6 mt-4 is-size-7">PASSWORD</div>

<div class="column is-6">
    <input v-model="email_username" placeholder="...." class="input is-fullwidth">
</div>

<div class="column is-6">
    <input v-model="email_password" placeholder="...." class="input is-fullwidth">
</div>

<div class="column has-text-centered is-4 mt-4 has-text-weight-bold has-text-danger" style="margin-bottom:-.2em;"> 
<button class="button is-fullwidth has-background-danger-light has-text-danger"><span class="icon mr-2 is-small has-text-danger"> <i class="fas fa-paper-plane"></i> </span>TEST</button>
</div> 

<div class="column has-text-centered is-8 mt-4 has-text-weight-bold has-text-danger" style="margin-bottom:-.2em;"> 
<button class="button is-fullwidth has-background-success-light has-text-success"><span class="icon mr-2 is-small has-text-success"> <i class="fas fa-save"></i> </span>SAVE</button>
</div>

</div></div>
<!-- END EMAIL  -->

<div class="column is-1"></div>

<div class="column is-3 box has-background-light">
<div class="columns is-multiline">
<div class="column is-12 underIT">SMS !! !!</div>

<div class="column is-4 mt-4 is-size-7">NUMBER</div>
<div class="column is-8">
    <input disabled placeholder="...." class="input is-fullwidth">
</div>

<div class="column is-4 mt-4 is-size-7">BALANCE</div>
<div class="column is-8">
    <input disabled placeholder="...." class="input is-fullwidth">
</div>

<div class="column has-text-centered is-12 has-text-weight-bold has-text-danger"> 
<button class="button is-fullwidth has-background-danger-light has-text-danger"><span class="icon mr-2 is-small has-text-danger"> <i class="fas fa-paper-plane"></i> </span>TEST</button>
</div> 


</div></div>


</div>
<!-- END MAIN COLUMN  -->





  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: '',
  props: [ '' ],

    data() {
        return {
            isLoading:false,

email_server:'',
email_username:'',
email_password:'',
sms_number:'',
sms_api:'',


        }
    },
 
mounted() {

    this.email_server = sessionStorage.getItem('email_server')
    this.email_username = sessionStorage.getItem('email_username')
    this.email_password = sessionStorage.getItem('email_password')
    this.sms_number = sessionStorage.getItem('sms_number')
    this.sms_api = sessionStorage.getItem('sms_api')

}, // END MOUNTED

methods: {






},





} // END EXPORT
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
